import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";
import { closeTooltip } from "../actions";

export function* investMagicResearchSaga({ govId, isOwner }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "investMagicResearch",
      govId
    });

    const { data } = JSON.parse(response.data);

    const {
      hasFinishedQuest,
      availableQuests,
      finishedQuests,
      spellsLimit,
      spellUpgradeAvailable,
      magicResearch,
      spellCastLimit,
      resources,
      resourceBalances,
      general,
      slotChains
    } = data;

    if (govId) {
      yield put(actions.updateMember(govId, {
        spellsLimit,
        spellUpgradeAvailable,
        magicResearch,
        spellCastLimit,
        resources: {
          gold: resources.gold,
          weapons: resources.weapons,
          mana: resources.mana,
          magicEnergy: resources.magicEnergy
        }
      }));
    }

    if (!govId || isOwner) {
      yield put(actions.updateState({
        spellsLimit,
        spellUpgradeAvailable,
        magicResearch,
        spellCastLimit
      }));

      yield put(actions.updateResources({
        resources,
        resourceBalances
      }));

      if (hasFinishedQuest) {
        yield put(actions.updateState({
          hasFinishedQuest,
          availableQuests,
          finishedQuests
        }));
      }

      if (slotChains) {
        yield put(actions.updateState({
          slotChains
        }));
      }

      if (general) {
        yield put(actions.updateGeneral(
          general
        ));
      }
    }

    yield put(closeTooltip("MagicResearchStepInfo"));
  } catch (error) {
    console.log(error.message);
  }
}

export function* learnSpellSaga({ spellId, govId, isOwner }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "learnSpell",
      spellId,
      govId
    });

    const { data } = JSON.parse(response.data);
    const {
      spellsLimit,
      spells
    } = data;

    if (govId) {
      yield put(actions.updateMember(govId, {
        spellsLimit,
        spells
      }));
    }

    if (!govId || isOwner) {
      yield put(actions.updateState({
        spellsLimit,
        spells
      }));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* upgradeSpellSaga({ familyId, govId, isOwner }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "upgradeSpell",
      familyId,
      govId
    });

    const { data } = JSON.parse(response.data);

    const {
      spellUpgradeAvailable,
      spells,
      resources,
      resourceBalances,
      magicCore,
      general
    } = data;

    if (govId) {
      yield put(actions.updateMember(govId, {
        resources: {
          gold: resources.gold,
          weapons: resources.weapons,
          mana: resources.mana,
          magicEnergy: resources.magicEnergy
        },
        spellUpgradeAvailable,
        spells
      }));
    }

    if (!govId || isOwner) {
      yield put(actions.updateState({
        spellUpgradeAvailable,
        spells
      }));

      if (resources) {
        yield put(actions.updateResources({
          resources,
          resourceBalances
        }));
      }

      if (magicCore) {
        yield put(actions.updateState({
          magicCore
        }));
      }

      if (general) {
        yield put(actions.updateGeneral(
          general
        ));
      }
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* disperseSpellSaga({ spellId, govId, isOwner }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "disperseSpell",
      spellId,
      govId
    });

    const { data } = JSON.parse(response.data);

    const {
      spells,
      resources,
      resourceBalances,
      general
    } = data;

    if (govId) {
      yield put(actions.updateMember(govId, {
        resources: {
          gold: resources.gold,
          weapons: resources.weapons,
          mana: resources.mana,
          magicEnergy: resources.magicEnergy
        },
        spells
      }));
    }

    if (!govId || isOwner) {
      yield put(actions.updateState({
        spells
      }));

      yield put(actions.updateResources({
        resources,
        resourceBalances
      }));

      if (general) {
        yield put(actions.updateGeneral(
          general
        ));
      }
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* castSpellSaga({ spellId, govId, isOwner }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "castSpell",
      spellId,
      govId
    });

    const { data } = JSON.parse(response.data);

    const {
      spells,
      resources,
      resourceBalances,
      general,
      turnNews,
      hasFinishedQuest,
      availableQuests,
      finishedQuests
    } = data;

    if (govId) {
      yield put(actions.updateMember(govId, {
        resources: {
          gold: resources.gold,
          weapons: resources.weapons,
          mana: resources.mana,
          magicEnergy: resources.magicEnergy
        },
        spells
      }));
    }

    if (!govId || isOwner) {
      yield put(actions.updateState({
        spells
      }));

      yield put(actions.updateResources({
        resources,
        resourceBalances
      }));

      if (general) {
        yield put(actions.updateGeneral(
          general
        ));
      }

      if (turnNews) {
        yield put(actions.updateState({
          turnNews
        }));
      }

      if (hasFinishedQuest) {
        yield put(actions.updateState({
          hasFinishedQuest,
          availableQuests,
          finishedQuests
        }));
      }
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* planSpellSaga({
  spellId,
  targetId,
  level,
  spellOn,
  emperorTent,
  sender,
  isOwner
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "planSpell",
      spellId,
      targetId,
      level,
      spellOn,
      emperorTent,
      sender
    });

    const { data } = JSON.parse(response.data);
    const {
      spells,
      magicCore,
      spellCastLimit
    } = data;

    if (sender) {
      yield put(actions.updateMember(sender, {
        spells,
        magicCore,
        spellCastLimit
      }));
    }

    if (!sender || isOwner) {
      yield put(actions.updateState({
        spells,
        magicCore,
        spellCastLimit
      }));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* updateSpellSaga({
  spellTableId,
  upType,
  upValue,
  emperorTent,
  sender,
  isOwner
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "updateSpell",
      spellTableId,
      upType,
      upValue,
      emperorTent,
      sender
    });

    const { data } = JSON.parse(response.data);
    const {
      spells,
      magicCore
    } = data;

    if (sender) {
      yield put(actions.updateMember(sender, {
        spells,
        magicCore,
      }));
    }

    if (!sender || isOwner) {
      yield put(actions.updateState({
        spells,
        magicCore
      }));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* toggleMagicPlanSaga({
  close,
  emperorTent,
  govId,
  isOwner
}: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "toggleMagicPlan",
      close,
      emperorTent,
      sender: govId
    });
    const { data } = JSON.parse(response.data);
    const {
      magicClosed,
      resources,
      resourceBalances
    } = data;

    if (govId) {
      yield put(actions.updateMember(govId, {
        resources: {
          gold: resources.gold,
          weapons: resources.weapons,
          mana: resources.mana,
          magicEnergy: resources.magicEnergy
        },
        magicClosed
      }));
    }

    if (!govId || isOwner) {
      yield put(actions.updateState({
        magicClosed
      }));

      yield put(actions.updateResources({
        resources,
        resourceBalances
      }));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* setMagicModeSaga({ newMagicMode, govId, isOwner }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "setMagicMode",
      magicMode: newMagicMode,
      govId
    });

    const { data } = JSON.parse(response.data);
    const {
      magicMode,
      general
    } = data;

    if (govId) {
      yield put(actions.updateMember(govId, {
        magicMode
      }));
    }

    if (!govId || isOwner) {
      yield put(actions.updateState({
        magicMode
      }));

      yield put(actions.updateGeneral(
        general
      ));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* setAutocastSaga({ spellId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "setAutocast",
      spellId
    });

    const { data } = JSON.parse(response.data);
    const {
      autocast
    } = data;

    yield put(actions.updateState({
      autocast
    }));
  } catch (error) {
    console.log(error.message);
  }
}
